module.exports = __webpack_public_path__ + "static/media/30.af52e31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/30.png
// module id = 813
// module chunks = 0